const displayTypes = {
  desktopSingle: {
    maxWidth: '220px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  desktopStream: {
    maxWidth: 'inherit',
    overflow: 'inherit',
    textOverflow: 'none',
    whiteSpace: 'inherit',
  },
  mobileStream: {
    maxWidth: 'inherit',
    overflow: 'inherit',
    textOverflow: 'none',
    whiteSpace: 'inherit',
  },
}

const accountName = (display) => ({
  fontWeight: 700,
  color: '#262626',
  position: 'relative',
  maxWidth: displayTypes[display].maxWidth,
  overflow: displayTypes[display].overflow,
  textOverflow: displayTypes[display].textOverflow,
  whiteSpace: displayTypes[display].whiteSpace,
})

export { accountName }
